export const categories = [
  {
    label: "Account",
    image:
      "https://cdn.pixabay.com/photo/2015/02/02/11/09/office-620822_960_720.jpg",
    href: "#section1",
  },
  {
    label: "Orders",
    image:
      "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=465&q=80",
    href: "#section2",
  },
  {
    label: "Payments",
    image:
      "https://images.unsplash.com/photo-1609429019995-8c40f49535a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80",
    href: "#section3",
  },
];

export const accFaq = [
  {
    question: "How do I create an account?",
    answer:
      "Creating your Lux Woodwork account is very easy! Simply click on the 'Sign Up' button on the top right of the page and fill out the form. You will then be able to log in to your account and start shopping!",
  },
  {
    question: "Can I login using my social account such as Google?",
    answer:
      "Yes! Lux Woodwork supports social login, including Google. Simply click on the 'Sign In' button on the top right of the page and click on the Google icon. You will then be redirected to the Google login page where you can login using your Google account.",
  },
  {
    question: "I forgot my paassword, what do I do?",
    answer:
      "You can reset your password by clicking on the 'Forgot Password?' link on the login page. You will then be redirected to a page where you can enter your email address and reset your password.",
  },
  {
    question: "I want to change my password, how do I do that?",
    answer:
      "You can change your password by clicking on the 'Account' button on the top right of the page and then clicking on the 'Change Password' button.",
  },
  {
    question: "I want to edit my personal details, how do I do that?",
    answer:
      "You can edit your personal details by clicking on the 'Account' button on the top right of the page and then clicking on the 'Edit Details' button.",
  },
];

export const ordersFaq = [
  {
    question: "How do I place an order?",
    answer: "To place an order, simply add the item to your cart and checkout.",
  },

  {
    question: "How can I avoid failed deliveries?",
    answer:
      "Make sure you provide a valid address and contact number. Double-check your delivery informaation before placing your order.",
  },
  {
    question: "Can I order without a Lux Woodwork account?",
    answer:
      "No, you need to have an account to place an order. For instructions on how to order, please read the section on account",
  },
  {
    question: "How do I remove an item from my cart?",
    answer:
      "To remove an item from your cart, simply click on the 'Remove' button.",
  },
  {
    question: "How do I change the quantity of an item in my cart?",
    answer:
      "To change the quantity of an item in your cart, simply click on the '+' or '-' button.",
  },
];

export const paymentsFaq = [
  {
    question: "What payment systems do you work with?",
    answer:
      "Lux Woodwork currently supports PayPal and credit card payment. We are working on adding more payment systems in the future.",
  },
  {
    question: "How do I pay using PayPal?",
    answer:
      "To pay using PayPal, simply select PayPal as your payment method and provide the requested information.",
  },
  {
    question:
      "What should I do if someone asks me to pay for my order using a different payment method?",
    answer:
      " Do not pay for your order using a different payment method. If you have any questions, please contact us.",
  },
  {
    question: "What should I do if I have been scammed?",
    answer: "Please contact us immediately.",
  },
  {
    question: "I found a transcation that I didn't make. What should I do?",
    answer: "Please contact your bank immeditely.",
  },
];
